/* flow-strict */

export let fbSdk = window.FB;
import { FB_APP_ID } from '/client/src/constants';
// TODO
// app.on("fb.setSize").then((size) => {
//   if (fbSdk && fbSdk.Canvas) {
//     fbSdk.Canvas.setSize(size);
//   }
// })
// app.on("fb.scrollTo").then((top, offset_top?) => {
//   if (fbSdk && fbSdk.Canvas) {
//     fbSdk.Canvas.getPageInfo((info) => {
//       offset_top = offset_top || 200;
//       fbSdk.Canvas.scrollTo(0, (top + info.offsetTop - offset_top));
//     });
//   }
// })

/**
 * Initialize facebook sdk
 */
export const init = () => {
  if (window.FB) {
    fbSdk = window.FB;
  }

  // Load facebook sdk from the page
  return new Promise((resolve, reject) => {
    if (!fbSdk) {
      reject(1);
      return;
    }

    fbSdk.init({
      appId: FB_APP_ID,
      autoLogAppEvents : true,
      xfbml: true,
      status: true,
      cookie: true,
      // version: 'v2.10'
      version          : 'v9.0'
    });

    resolve(fbSdk);
  });
};
